import React, { Component, Fragment } from "react";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import axios from "axios";
import { connect } from "react-redux";
import {
  getAllOrders,
  getAllOrdersSingleUser,
  updateTransactionOrderStatus,
  getSingleProduct,
  getSingleOrder,
} from "../../firebase/firebase.utils";
import SteadFast from "../1688-taobao-orders/steadFast.png";
import Pathao from "../1688-taobao-orders/pathao.png";
import { ToastContainer, toast } from "react-toastify";
import { sendNotifications } from "../../firebase/fcmRestApi";
// steadFast api credential
const api_key = "f6wue85mqhr156uctcptdfkldnktwjp4 ";
const secret_key = "nmjzsxcivg63m4ihpyd3ekvk ";
const base_url = "https://portal.packzy.com/api/v1";

export class Tabset_user extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderObj: null,
      orders: [],
    };
  }

  componentDidMount = async () => {
    const { userId } = this.props;
    console.log(userId);
    let orders = await getAllOrdersSingleUser(userId);
    this.setState({
      orders: orders,
    });
    console.log(orders);
  };

  calculateCart = (orders) => {
    let cartProducts = orders;
    let sumAmount = 0;
    let actualOrder = 0;

    //find and create array
    cartProducts &&
      cartProducts.length > 0 &&
      cartProducts.forEach((item, index) => {
        let price = this.getPrice4(item);
        let salePrice = this.getPrice2(item);
        console.log(price);
        console.log(item.quantity);
        actualOrder += parseInt(parseInt(price) * item.quantity);
        sumAmount += parseInt(parseInt(salePrice) * item.quantity);
      });

    return { actualOrder, sumAmount };
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  handleSearchBarChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  clickActive = (event) => {
    document.querySelector(".nav-link").classList.remove("show");
    event.target.classList.add("show");
  };

  createNotification = (order) => {
    let msg;
    console.log(order);

    if (order.orderStatus === "Processing") {
      msg = {
        title: "Order Processing",
        body: `We are processing your order.One of our team member is assigned for your order. OrderId:-${order.id}.`,
      };
      return msg;
    }
    if (order.orderStatus === "Confirmed") {
      msg = {
        title: "Order Confirmed",
        body: `Your order is confirmed. OrderId:-${order.id}.`,
      };
      return msg;
    }
    if (order.orderStatus === "Packing") {
      msg = {
        title: "Reday for delivery",
        body: `We are packaging your order. OrderId:-${order.id}.`,
      };
      return msg;
    }
    if (order.orderStatus === "On the way") {
      msg = {
        title: "On the way",
        body: `Your parcel is out for delivery. OrderId:-${order.id}.`,
      };
      return msg;
    }
    if (order.orderStatus === "Delivered") {
      msg = {
        title: "Order delivered successfully",
        body: `Your order is delivered. OrderId:-${order.id}. Thank you`,
      };
      return msg;
    }
    if (order.orderStatus === "Cancelled") {
      msg = {
        title: "Sorry. Order cancelled",
        body: `Your order is cancelled. OrderId:-${order.id}.Contact our customer service to get detail info.Thanks`,
      };
      return msg;
    }
  };

  handleCourier = async (codAmount) => {
    const { orderObj } = this.state;
    let note = this.state.note;
    if (this.state.courier == "SteadFast") {
      const create_order = `${base_url}/create_order`;

      console.log(note);
      axios
        .post(
          create_order,
          {
            invoice: `${orderObj.id}`,
            recipient_name: orderObj.currentUser
              ? orderObj.currentUser.address.find(
                  (address) => address.defaultShipping,
                ).fullName
              : orderObj.guest.address.find(
                  (address) => address.defaultShipping,
                ).fullName,
            recipient_phone: orderObj.currentUser
              ? orderObj.currentUser.address.find(
                  (address) => address.defaultShipping,
                ).mobileNo
              : orderObj.guest.address.find(
                  (address) => address.defaultShipping,
                ).mobileNo,
            recipient_address: orderObj.currentUser
              ? `${
                  orderObj.currentUser.address.find(
                    (address) => address.defaultShipping,
                  ).address
                },${
                  orderObj.currentUser.address.find(
                    (address) => address.defaultShipping,
                  ).district
                },${
                  orderObj.currentUser.address.find(
                    (address) => address.defaultShipping,
                  ).division
                }`
              : `${
                  orderObj.guest.address.find(
                    (address) => address.defaultShipping,
                  ).address
                },${
                  orderObj.guest.address.find(
                    (address) => address.defaultShipping,
                  ).district
                },${
                  orderObj.guest.address.find(
                    (address) => address.defaultShipping,
                  ).division
                }`,
            cod_amount: codAmount,
            note: note,
          }, // Request body (if needed)
          {
            headers: {
              "Api-Key": api_key,
              "Secret-Key": secret_key,
              "Content-Type": "application/json",
            },
          },
        )
        .then(async (response) => {
          console.log(note);
          await this.props.updateOrderRedux({
            ...orderObj,
            courier: { ...response.data, note: note },
          });
          toast.success(
            "Consignment has been created successfully at steadfast!",
          );
          window.document.getElementById("close-btn-courier").click();
        })
        .catch((error) => {
          toast.error("Error creating consignment at steadfast.");
        });
      console.log("Handle submit is getting called!");
    } else {
      // for pathao
      // first get the access token
      if (!this.state.cityObject) {
        alert("You must choose a city");
        return;
      }
      if (!this.state.zoneObject) {
        alert("You must choose a zone");
        return;
      }
      if (!this.state.access_token) {
        alert(
          "Your token is expired. Please open and close the modal windo again",
        );
        window.document.getElementById("close-btn-courier").click();
        return;
      }

      let baseUrl = `https://admin.chinatrade.com.bd`;

      let totalQuantity = 0;
      orderObj.orders.map((order) => {
        totalQuantity += order.quantity;
      });
      // create order here
      let order = {
        store_id: 151431,
        merchant_order_id: `${orderObj.id}`,
        recipient_name: orderObj.currentUser
          ? orderObj.currentUser.address.find(
              (address) => address.defaultShipping,
            ).fullName
          : orderObj.guest.address.find((address) => address.defaultShipping)
              .fullName,
        recipient_phone: orderObj.currentUser
          ? orderObj.currentUser.address.find(
              (address) => address.defaultShipping,
            ).mobileNo
          : orderObj.guest.address.find((address) => address.defaultShipping)
              .mobileNo,
        recipient_address: orderObj.currentUser
          ? `${
              orderObj.currentUser.address.find(
                (address) => address.defaultShipping,
              ).address
            },${
              orderObj.currentUser.address.find(
                (address) => address.defaultShipping,
              ).district
            },${
              orderObj.currentUser.address.find(
                (address) => address.defaultShipping,
              ).division
            }`
          : `${
              orderObj.guest.address.find((address) => address.defaultShipping)
                .address
            },${
              orderObj.guest.address.find((address) => address.defaultShipping)
                .district
            },${
              orderObj.guest.address.find((address) => address.defaultShipping)
                .division
            }`,
        delivery_type: 48,
        item_type: 2,
        special_instruction: note,
        item_quantity: parseInt(totalQuantity),
        item_weight: this.state.weight
          ? parseFloat(this.state.weight).toFixed(2)
          : parseFloat(1),
        item_description: "",
        amount_to_collect: parseInt(codAmount),
        recipient_city: parseInt(this.state.cityObject.city_id),
        recipient_zone: parseInt(this.state.zoneObject.zone_id),
      };
      console.log(order);
      axios
        .post(`${baseUrl}/api/create-order`, order, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.state.access_token}`,
          },
        })
        .then(async (response) => {
          console.log(response);
          if (response.data.code == 200) {
            console.log(note);
            await this.props.updateOrderRedux({
              ...orderObj,
              courier: {
                ...response.data.data,
                pathao: true,
                weight: this.state.weight ? this.state.weight : 1,
                city: this.state.cityObject,
                zone: this.state.zoneObject,
                note: note,
              },
            });
            toast.success(
              "Consignment has been created successfully at pathao!",
            );
          } else {
            alert("error creating consignment. Please try again later.");
          }
        })
        .catch((error) => {
          alert("error creating order.");
        });
    }

    this.setState({
      name: "",
      quantity: "",
      amount: "",
      description: "",
      orderObj: null,
      loading: false,
      imageUrl: "",
      file: "",
      shippingCost: "",
      agentCost: "",
      status: "",
      warehouse: "",
      orderStatus: "",
      courier: "",
      note: "",
    });
  };
  handleReceive = async () => {
    let date = new Date();
    if (!this.state.warehouse) {
      alert("Please select an warehouse first.");
    }
    let bookings = this.props.p2p.filter((product) =>
      this.state.checkedValues.includes(product.id),
    );

    for (let i = 0; i < bookings.length; i++) {
      await this.props.updateOrderRedux({
        ...bookings[i],
        status: this.state.warehouse,
        toWarehouse: this.state.warehouse,
        toWarehouseReceiveDate: date.toLocaleDateString("en-GB"),
        deliveryWarehouse: true,
      });
    }
    this.setState({
      warehouse: "",
      checkedValues: [],
    });
  };
  handleDelivery = async () => {
    let date = new Date();
    let bookings = this.props.p2p.filter((product) =>
      this.state.checkedValues.includes(product.id),
    );

    for (let i = 0; i < bookings.length; i++) {
      await this.props.updateOrderRedux({
        ...bookings[i],
        status: "delivered",
        deliveryDate: date.toLocaleDateString("en-GB"),
      });
    }
    this.setState({
      warehouse: "",
      checkedValues: [],
    });
  };

  getUserName = (agentId) => {
    const { users } = this.props;
    if (users.length > 0) {
      const agentName = users.find((user) => user.uid === agentId);
      if (agentName) {
        return agentName.displayName;
      } else {
        return "";
      }
    } else {
      return "";
    }
  };

  selectRow = (e, i) => {
    if (!e.target.checked) {
      this.setState({
        checkedValues: this.state.checkedValues.filter((item, j) => i !== item),
      });
    } else {
      this.setState({
        checkedValues: [...this.state.checkedValues, i],
      });
    }
  };
  selectRow2 = (e, i) => {
    if (!e.target.checked) {
      this.setState({
        checkedValues2: this.state.checkedValues2.filter(
          (item, j) => i !== item,
        ),
      });
    } else {
      this.setState({
        checkedValues2: [...this.state.checkedValues2, i],
      });
    }
  };

  singleProductTotal = (product) => {
    let total = parseInt(this.getPrice2(product)) * product.quantity;
    return total;
  };

  getPrice2 = (product) => {
    if (product.selectedVariation.id) {
      if (product.selectedVariation.salePrice == 0) {
        return product.selectedVariation.price;
      } else {
        return product.selectedVariation.salePrice;
      }
    } else {
      if (product.product) {
        if (product.product.salePrice == 0) {
          return product.product.price;
        } else {
          return product.product.salePrice;
        }
      } else {
        return 0;
      }
    }
  };

  getMonthName = () => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const d = new Date();
    return `${monthNames[d.getMonth()]},${d.getFullYear()}`;
  };

  handleSubmit = async () => {
    console.log("Handle submit is getting called!");
    let orderObj = {
      ...this.state.orderObj,
      orderStatus: this.state.orderStatus,
      [`${this.state.orderStatus.toLowerCase()}Date`]: new Date()
        .getTime()
        .toString(),
      orderStatusScore:
        this.state.orderStatus == "Processing"
          ? 2
          : this.state.orderStatus == "Confirmed"
            ? 3
            : this.state.orderStatus == "Packing"
              ? 4
              : this.state.orderStatus == "On the way"
                ? 5
                : this.state.orderStatus == "Delivered"
                  ? 6
                  : 0,
      cancelNote: this.state.cancelNote,
    };

    await this.props.updateOrderRedux(orderObj);
    const msg = this.createNotification(orderObj);
    const message = {
      title: msg.title,
      body: msg.body,
    };
    if (
      orderObj &&
      orderObj.currentUser &&
      orderObj.currentUser.deviceToken &&
      orderObj.currentUser.deviceToken.length > 0
    ) {
      orderObj.currentUser.deviceToken.map((token) => {
        console.log(token);
        sendNotifications(token, message);
      });
    }

    for (let i = 0; i < orderObj.orders.length; i++) {
      let product = await getSingleProduct(orderObj.orders[i].productId);
      let order = orderObj.orders[i];
      if (this.state.orderStatus == "Cancelled") {
        if (
          product.displayedVariations &&
          product.displayedVariations.length > 0
        ) {
          await this.props.updateSingleProductRedux({
            ...product,
            displayedVariations: product.displayedVariations.map(
              (variation) => {
                if (order.selectedVariation.id == variation.id) {
                  return {
                    ...variation,
                    totalSold: variation.totalSold
                      ? variation.totalSold - parseInt(order.quantity)
                      : 0,
                    inventory:
                      parseInt(variation.inventory) +
                      parseInt(
                        orderObj.orders.find(
                          (order) => order.selectedVariation.id == variation.id,
                        ).quantity,
                      ),
                  };
                } else {
                  return variation;
                }
              },
            ),
          });
          let date = new Date();
          this.props.uploadTransactionRedux({
            id: date.getTime().toString() + i,
            fundType: "Buying",
            subCategory: `Order Id:${orderObj.id}`,
            month: this.getMonthName(),
            date: date.toLocaleDateString("en-GB"),
            purchasePrice: "Cancelled by admin",
            cancelNote: this.state.cancelNote,
            orderStatus: "Cancelled",
            totalCost: this.singleProductTotal(orderObj.orders[i]),
            perUnitPrice: this.getPrice2(orderObj.orders[i]),
            expenseBy: this.props.currentAdmin
              ? this.props.currentAdmin.name
              : "",
            unEditable: true,
            productId: product.id,
            productStock: orderObj.orders[i].quantity,
            remainingStock:
              parseInt(
                product.displayedVariations.find(
                  (variation) => variation.id == order.selectedVariation.id,
                ).inventory,
              ) + parseInt(order.quantity),
            productName: product.name,
            productImage: product.pictures[0],
            variationId: order.selectedVariation.id,
          });
        } else {
          await this.props.updateSingleProductRedux({
            ...product,
            totalSold: product.totalSold
              ? parseInt(product.totalSold) -
                parseInt(orderObj.orders[i].quantity)
              : 0,
            inventory:
              parseInt(product.inventory) +
              parseInt(orderObj.orders[i].quantity),
          });
          let date = new Date();
          this.props.uploadTransactionRedux({
            id: date.getTime().toString() + i,
            fundType: "Buying",
            subCategory: `Order Id:${orderObj.id}`,
            month: this.getMonthName(),
            date: date.toLocaleDateString("en-GB"),
            purchasePrice: "Cancelled by admin",
            cancelNote: this.state.cancelNote,
            orderStatus: "Cancelled",
            totalCost: this.singleProductTotal(orderObj.orders[i]),
            perUnitPrice: this.getPrice2(orderObj.orders[i]),
            expenseBy: this.props.currentAdmin
              ? this.props.currentAdmin.name
              : "",
            unEditable: true,
            productId: product.id,
            productStock: orderObj.orders[i].quantity,
            remainingStock:
              parseInt(product.inventory) +
              parseInt(orderObj.orders[i].quantity),
            productName: product.name,
            productImage: product.pictures[0],
          });
        }
      }
    }
    await updateTransactionOrderStatus({
      orderId: orderObj.id,
      orderStatus: this.state.orderStatus,
    });
    this.setState({
      name: "",
      quantity: "",
      amount: "",
      description: "",
      orderObj: null,
      loading: false,
      imageUrl: "",
      file: "",
      shippingCost: "",
      agentCost: "",
      status: "",
      warehouse: "",
      orderStatus: "",
      courier: "",
      note: "",
      cancelNote: "",
    });
  };
  handleSubmit2 = async (event, totalDue) => {
    event.preventDefault();

    if (totalDue != 0 && this.state.amount == 0) {
      alert("Paid amount must be more than 0");
      return;
    }
    if (this.state.amount > totalDue) {
      alert("Paid amount can't be more than due amount.");
      return;
    }
    console.log(this.state);
    if (this.state.loader) {
      return;
    }
    this.setState({
      loader: true,
    });
    await this.props.updateOrderRedux({
      ...this.state.orderObj,
      paymentStatus:
        this.state.paymentStatus !== ""
          ? this.state.paymentStatus
          : this.state.orderObj.paymentStatus
            ? this.state.orderObj.paymentStatus
            : "purchaseLater",
      payments:
        this.state.orderObj.payments && this.state.orderObj.payments.length > 0
          ? [
              ...this.state.orderObj.payments,
              {
                amount: this.state.amount,
                method: this.state.method,
                receivedBy:
                  this.props.currentAdmin && this.props.currentAdmin.name
                    ? this.props.currentAdmin.name
                    : "",
                date: new Date().toLocaleDateString("en-GB"),
                transactionId: this.state.transactionId,
              },
            ]
          : [
              {
                amount: this.state.amount,
                method: this.state.method,
                receivedBy:
                  this.props.currentAdmin && this.props.currentAdmin.name
                    ? this.props.currentAdmin.name
                    : "",
                date: new Date().toLocaleDateString("en-GB"),
                transactionId: this.state.transactionId,
              },
            ],
    });

    let date = new Date();
    let cashInObj = {
      id: date.getTime().toString(),
      category: "ORDERS",
      subCategory: this.state.method,
      month: this.getMonthName(),
      date: date.toLocaleDateString("en-GB"),
      note: `Order Id:${this.state.orderObj.id}`,
      amount: this.state.amount,
      receiveBy:
        this.props.currentAdmin && this.props.currentAdmin.name
          ? this.props.currentAdmin.name
          : "",
      status: "pending",
      unEditable: true,
    };

    await this.props.uploadCashInRedux(cashInObj);
    toast.success("successfully updated the payment");

    this.setState({
      method: "",
      amount: "",
      paymentStatus: "",
      transactionId: "",
      loader: false,
    });
    document.getElementById("close-button-for-payment-modal").click();
  };
  handleSubmit3 = async (event) => {
    event.preventDefault();

    console.log(this.state);
    if (this.state.loader3) {
      return;
    }
    this.setState({
      loader3: true,
    });
    await this.props.updateOrderRedux({
      ...this.state.orderObj,
      courierCharge: this.state.orderObj.courierCharge
        ? parseInt(this.state.orderObj.courierCharge) +
          parseInt(this.state.courierCharge)
        : this.state.courierCharge,
    });

    let date = new Date();
    let expenseObj = {
      id: date.getTime().toString(),
      category: "COURIER",
      subCategory: `courier charge`,
      month: this.getMonthName(),
      date: date.toLocaleDateString("en-GB"),
      note: `Order Id:${this.state.orderObj.id}`,
      amount: this.state.courierCharge,
      receiveBy:
        this.props.currentAdmin && this.props.currentAdmin.name
          ? this.props.currentAdmin.name
          : "",
      status: "pending",
      unEditable: true,
    };

    await this.props.uploadExpenseRedux(expenseObj);
    toast.success("successfully updated the payment");

    this.setState({
      method: "",
      amount: "",
      paymentStatus: "",
      transactionId: "",
      loader: false,
      courierCharge: "",
      loader3: false,
    });
    document.getElementById("close-button-for-payment-modal").click();
  };
  getPrice3 = (product) => {
    if (product.selectedVariation.id) {
      if (product.selectedVariation.salePrice == 0) {
        return "";
      } else {
        return `৳ ${product.selectedVariation.price}`;
      }
    } else {
      if (product.product) {
        if (product.product.salePrice == 0) {
          return "";
        } else {
          return `৳ ${product.product.price}`;
        }
      } else {
        return 0;
      }
    }
  };
  getPrice4 = (product) => {
    if (product.selectedVariation.id) {
      return product.selectedVariation.price;
    } else {
      if (product.product) {
        return product.product.price;
      } else {
        return 0;
      }
    }
  };

  handleCashOut = async (p2pArray) => {
    const { currentAdmin } = this.props;
    let date = new Date();
    if (p2pArray.length == 0) {
      alert("Please select at least one p2p agent to pay");
      return;
    }
    for (let i = 0; i < p2pArray.length; i++) {
      const p2pObj = p2pArray[i];
      console.log(date.getTime().toString());
      console.log(p2pObj);
      await this.props.handleP2pAgentPayRedux({
        ...p2pObj,
        paymentId: `${date.getTime().toString()}${i}`,
        month: this.getMonthName(),
        date: date.toLocaleDateString("en-GB"),
        receiveBy: currentAdmin.name,
      });
    }
    this.setState({
      checkedValues2: [],
    });
  };

  updateOrder = async () => {
    console.log("Handle submit is getting called!");
    let orderObj = {
      ...this.state.orderObj,
    };
    let previousOrder = await getSingleOrder(orderObj.id);
    let previousOrdersArray = previousOrder.orders;
    let newOrdersArray = orderObj.orders;
    const getDifferenceArray = this.getDifferenceArray(
      previousOrdersArray,
      newOrdersArray,
    );
    console.log(getDifferenceArray);
    await this.props.updateOrderRedux(orderObj);
    const msg = this.createNotification(orderObj);
    const message = {
      title: msg.title,
      body: msg.body,
    };
    if (
      orderObj &&
      orderObj.currentUser &&
      orderObj.currentUser.deviceToken &&
      orderObj.currentUser.deviceToken.length > 0
    ) {
      orderObj.currentUser.deviceToken.map((token) => {
        console.log(token);
        sendNotifications(token, message);
      });
    }
    let orders = getDifferenceArray;
    console.log(orders);
    for (let i = 0; i < orders.length; i++) {
      let order = orders[i];
      if (orders[i].unchanged) {
      } else {
        let product = await getSingleProduct(orders[i].productId);
        if (
          product.displayedVariations &&
          product.displayedVariations.length > 0
        ) {
          if (orders[i].decreased) {
            await this.props.updateSingleProductRedux({
              ...product,
              displayedVariations: product.displayedVariations.map(
                (variation) => {
                  if (order.selectedVariation.id == variation.id) {
                    return {
                      ...variation,
                      totalSold: variation.totalSold
                        ? variation.totalSold - parseInt(order.quantity)
                        : 0,
                      inventory:
                        parseInt(variation.inventory) +
                        parseInt(
                          orders.find(
                            (order) =>
                              order.selectedVariation.id == variation.id,
                          ).quantity,
                        ),
                    };
                  } else {
                    return variation;
                  }
                },
              ),
            });
            let date = new Date();
            this.props.uploadTransactionRedux({
              id: date.getTime().toString() + i,
              fundType: "Buying",
              subCategory: `Order Id:${orderObj.id}`,
              month: this.getMonthName(),
              date: date.toLocaleDateString("en-GB"),
              purchasePrice: "Partial delivered",
              cancelNote: "Item quantity reduced from order",
              orderStatus: orderObj.orderStatus,
              totalCost: this.singleProductTotal(orders[i]),
              perUnitPrice: this.getPrice2(orders[i]),
              expenseBy: this.props.currentAdmin
                ? this.props.currentAdmin.name
                : "",
              unEditable: true,
              productId: product.id,
              productStock: orders[i].quantity,
              remainingStock:
                parseInt(
                  product.displayedVariations.find(
                    (variation) => variation.id == order.selectedVariation.id,
                  ).inventory,
                ) + parseInt(order.quantity),
              productName: product.name,
              productImage: product.pictures[0],
              variationId: order.selectedVariation.id,
            });
          }
          if (orders[i].increased) {
            await this.props.updateSingleProductRedux({
              ...product,
              displayedVariations: product.displayedVariations.map(
                (variation) => {
                  if (order.selectedVariation.id == variation.id) {
                    return {
                      ...variation,
                      totalSold: variation.totalSold
                        ? variation.totalSold + parseInt(order.quantity)
                        : parseInt(order.quantity),
                      inventory:
                        parseInt(variation.inventory) -
                        parseInt(
                          orders.find(
                            (order) =>
                              order.selectedVariation.id == variation.id,
                          ).quantity,
                        ),
                    };
                  } else {
                    return variation;
                  }
                },
              ),
            });
            let date = new Date();
            this.props.uploadTransactionRedux({
              id: date.getTime().toString() + i,
              fundType: "Selling",
              subCategory: `Order Id:${orderObj.id}`,
              orderStatus: orderObj.orderStatus,
              month: this.getMonthName(),
              date: date.toLocaleDateString("en-GB"),
              totalBill: this.singleProductTotal(orders[i]),
              perUnitPrice: this.getPrice2(orders[i]),
              expenseBy: this.props.currentAdmin
                ? this.props.currentAdmin.name
                : "",
              note: "Increased quantity",
              unEditable: true,
              productId: product.id,
              sellStock: orders[i].quantity,
              remainingStock:
                parseInt(
                  product.displayedVariations.find(
                    (variation) => variation.id == order.selectedVariation.id,
                  ).inventory,
                ) - parseInt(order.quantity),
              productName: product.name,
              productImage: product.pictures[0],
              variationId: order.selectedVariation.id,
            });
          }
        } else {
          if (orders[i].decreased) {
            await this.props.updateSingleProductRedux({
              ...product,
              totalSold: product.totalSold
                ? parseInt(product.totalSold) - parseInt(orders[i].quantity)
                : 0,
              inventory:
                parseInt(product.inventory) + parseInt(orders[i].quantity),
            });
            let date = new Date();
            this.props.uploadTransactionRedux({
              id: date.getTime().toString() + i,
              fundType: "Buying",
              subCategory: `Order Id:${orderObj.id}`,
              month: this.getMonthName(),
              date: date.toLocaleDateString("en-GB"),
              purchasePrice: "Partial delivered",
              cancelNote: "Item quantity reduced from order",
              orderStatus: orderObj.orderStatus,
              totalCost: this.singleProductTotal(orders[i]),
              perUnitPrice: this.getPrice2(orders[i]),
              expenseBy: this.props.currentAdmin
                ? this.props.currentAdmin.name
                : "",
              unEditable: true,
              productId: product.id,
              productStock: orders[i].quantity,
              remainingStock:
                parseInt(product.inventory) + parseInt(orders[i].quantity),
              productName: product.name,
              productImage: product.pictures[0],
            });
          }
          if (orders[i].increased) {
            await this.props.updateSingleProductRedux({
              ...product,
              totalSold: product.totalSold
                ? product.totalSold + parseInt(orders[i].quantity)
                : parseInt(orders[i].quantity),
              inventory:
                parseInt(product.inventory) - parseInt(orders[i].quantity),
            });
            let date = new Date();
            this.props.uploadTransactionRedux({
              id: date.getTime().toString() + i,
              fundType: "Selling",
              subCategory: `Increased quantity in Order Id:${orderObj.id}`,
              orderStatus: orderObj.orderStatus,
              month: this.getMonthName(),
              date: date.toLocaleDateString("en-GB"),
              totalBill: this.singleProductTotal(orders[i]),
              perUnitPrice: this.getPrice2(orders[i]),
              expenseBy: this.props.currentAdmin
                ? this.props.currentAdmin.name
                : "",
              unEditable: true,
              productId: product.id,
              sellStock: orders[i].quantity,
              remainingStock:
                parseInt(product.inventory) - parseInt(orders[i].quantity),
              productName: product.name,
              productImage: product.pictures[0],
            });
          }
        }
      }
    }

    this.setState({
      name: "",
      quantity: "",
      amount: "",
      description: "",
      orderObj: null,
      loading: false,
      imageUrl: "",
      file: "",
      shippingCost: "",
      agentCost: "",
      status: "",
      warehouse: "",
      orderStatus: "",
      courier: "",
      note: "",
      cancelNote: "",
    });
  };

  getProductKey = (product) =>
    `${product.productId}-${product.selectedVariation.id}`;

  // Function to get the difference array
  getDifferenceArray = (array1, array2) => {
    // Create a map of array1 for faster lookup
    const mapArray1 = array1.reduce((acc, item) => {
      const key = this.getProductKey(item);
      if (!acc[key]) {
        acc[key] = item;
      } else {
        acc[key].quantity += item.quantity; // In case there are duplicate productIds with different variations
      }
      return acc;
    }, {});

    // Create the result array
    const result = [];

    // Check for changes based on array2
    array2.forEach((item2) => {
      const key = this.getProductKey(item2);
      const item1 = mapArray1[key];

      if (item1) {
        // Product exists in both arrays, compare quantities
        if (item2.quantity > item1.quantity) {
          result.push({
            ...item2,
            quantity: item2.quantity - item1.quantity,
            increased: true,
          });
        } else if (item2.quantity < item1.quantity) {
          result.push({
            ...item2,
            quantity: item1.quantity - item2.quantity,
            decreased: true,
          });
        } else {
          result.push({
            ...item2,
            unchanged: true,
          });
        }

        // Remove the item from mapArray1 (it has been handled)
        delete mapArray1[key];
      } else {
        // Product exists in array2 but not in array1 (newly added)
        result.push({
          ...item2,
          increased: true,
        });
      }
    });

    // Check for removed items in array1 (those that are not in array2)
    Object.values(mapArray1).forEach((item1) => {
      result.push({
        ...item1,
        quantity: item1.quantity,
        decreased: true,
      });
    });

    return result;
  };

  toDateTime = (secs) => {
    var t = new Date(1970, 0, 1); // Epoch
    t.setSeconds(secs);

    return t.toLocaleDateString("en-US");
  };

  getPaymentMethod = (recharge) => {
    if (recharge.paymentMethod === "Cash") {
      return "Cash";
    }
    if (recharge.paymentMethod === "Bank") {
      return recharge.bankName;
    }
    if (recharge.paymentMethod === "Mobile Banking") {
      return recharge.mobileBanking;
    }
  };
  getColor = (booking) => {
    if (booking.bookingStatus === "Success") {
      return "green";
    }
    if (booking.bookingStatus === "Pending") {
      return "orange";
    }
    if (booking.bookingStatus === "Reject") {
      return "red";
    }
    if (booking.bookingStatus === "Received") {
      return "purple";
    }
  };
  render() {
    const { user, bookingsArray, rechargesArray, parcelsArray, paymentsArray } =
      this.props;
    const { orders, orderObj } = this.state;
    let renderableOrders = orders;
    let deliveryAddress = null;
    if (
      orderObj &&
      orderObj.currentUser &&
      orderObj.currentUser.address &&
      orderObj.currentUser.address.length > 0
    ) {
      deliveryAddress = orderObj.currentUser.address.find(
        (address) => address.defaultShipping,
      );
    } else if (
      orderObj &&
      orderObj.guest &&
      orderObj.guest.address &&
      orderObj.guest.address.length > 0
    ) {
      deliveryAddress = orderObj.guest.address.find(
        (address) => address.defaultShipping,
      );
    }

    let totalPaid = 0;
    if (orderObj && orderObj.payments && orderObj.payments.length > 0) {
      orderObj.payments.map((payment) => {
        totalPaid += parseInt(payment.amount);
      });
    }

    let amountPayable = 0;
    if (orderObj) {
      amountPayable =
        orderObj &&
        orderObj.subTotal +
          orderObj.deliveryCharge -
          orderObj.discountApplied -
          (orderObj.couponApplied ? orderObj.couponApplied.discount : 0) -
          (orderObj.finalDiscount ? orderObj.finalDiscount : 0);
    }
    return (
      <Fragment>
        <Tabs>
          <TabList
            className="nav nav-tabs tab-coupon"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Tab className="nav-link">Account info</Tab>
            <Tab className="nav-link">Delivery Addresses</Tab>
            <Tab className="nav-link">All Orders</Tab>
          </TabList>
          <TabPanel>
            <form className="needs-validation user-add" noValidate="">
              <h4>Account Details</h4>
              <div className="form-group row">
                <label className="col-xl-3 col-md-4">
                  <span>*</span> Name
                </label>
                <div
                  className="col-xl-8 col-md-7"
                  style={{ textTransform: "capitalize" }}
                >
                  {user && user.displayName}
                </div>
              </div>
              <div className="form-group row">
                <label className="col-xl-3 col-md-4">
                  <span>*</span> Status
                </label>
                <div className="col-xl-8 col-md-7">{user && user.status}</div>
              </div>
              <div className="form-group row">
                <label className="col-xl-3 col-md-4">
                  <span>*</span> Mobile No
                </label>
                <div className="col-xl-8 col-md-7">{user && user.mobileNo}</div>
              </div>
              <div className="form-group row">
                <label className="col-xl-3 col-md-4">
                  <span>*</span> Email
                </label>
                <div className="col-xl-8 col-md-7">{user && user.email}</div>
              </div>

              <div className="form-group row">
                <label className="col-xl-3 col-md-4">
                  <span>*</span> Company
                </label>
                <div className="col-xl-8 col-md-7">{user && user.company}</div>
              </div>

              <div className="form-group row">
                <label className="col-xl-3 col-md-4">
                  <span>*</span> Uid
                </label>
                <div className="col-xl-8 col-md-7">{user && user.uid}</div>
              </div>
              <div className="form-group row">
                <label className="col-xl-3 col-md-4">
                  <span>*</span> Created At
                </label>
                <div className="col-xl-8 col-md-7">
                  {user && this.toDateTime(user.createdAt.seconds)}
                </div>
              </div>
            </form>
          </TabPanel>
          <TabPanel>
            {user &&
              user.address &&
              user.address.length > 0 &&
              user.address.map((shippingAddress) => (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    padding: 10,
                    backgroundColor: shippingAddress.defaultShipping
                      ? "#d3e7e7"
                      : "white",
                    border: shippingAddress.defaultShipping
                      ? "1px solid cyan"
                      : "1px solid gainsboro",
                    borderRadius: 5,
                    marginTop: 10,
                    cursor: "pointer",
                  }}
                  key={shippingAddress.id}
                >
                  <div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                      }}
                    >
                      <div>
                        <i
                          className="icofont-location-pin"
                          style={{ fontSize: 30, color: "rgb(239 71 35)" }}
                        ></i>
                        <div
                          style={{
                            backgroundColor:
                              shippingAddress.addressType == "Home"
                                ? "green"
                                : shippingAddress.addressType == "Office"
                                  ? "blue"
                                  : "darkorange",
                            padding: 5,
                            paddingTop: 0,
                            paddingBottom: 0,
                            alignSelf: "center",
                            marginTop: 7,
                            borderRadius: 3,
                            color: "white",
                          }}
                        >
                          {shippingAddress.addressType}
                        </div>
                      </div>
                      <div style={{ marginLeft: 20 }}>
                        <div style={{ textAlign: "left", fontWeight: "bold" }}>
                          {shippingAddress.fullName}
                        </div>
                        <div style={{ textAlign: "left" }}>
                          {shippingAddress.mobileNo}
                        </div>
                        <div style={{ textAlign: "left" }}>
                          {shippingAddress.address}
                        </div>
                        <div style={{ textAlign: "left" }}>
                          {" "}
                          {shippingAddress.district},{shippingAddress.division}
                        </div>
                        {shippingAddress.defaultShipping && (
                          <div
                            style={{
                              marginTop: 7,
                              backgroundColor: "#0092ac",
                              alignSelf: "flex-start",
                              padding: 5,
                              paddingTop: 0,
                              paddingBottom: 0,
                              borderRadius: 5,
                              color: "white",
                              fontSize: 12,
                              display: "inline-block",
                              textAlign: "left",
                              float: "left",
                            }}
                          >
                            <i
                              className="icofont-check-circled"
                              style={{ fontWeight: "bold" }}
                            ></i>{" "}
                            Shipping Address
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </TabPanel>
          <TabPanel>
            <div
              id="basicScenario"
              className="product-physical"
              style={{ marginTop: 20 }}
            >
              <table className="table table-bordered table-striped table-hover">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      style={{
                        padding: "30px 15px",
                        color: "white",
                        backgroundColor: "rgb(251, 148, 4)",
                      }}
                    >
                      #
                    </th>
                    <th
                      scope="col"
                      style={{
                        padding: "30px 15px",
                        color: "white",
                        backgroundColor: "rgb(251, 148, 4)",
                      }}
                    >
                      Order Id
                    </th>
                    <th
                      scope="col"
                      style={{
                        padding: "30px 15px",
                        color: "white",
                        backgroundColor: "rgb(251, 148, 4)",
                      }}
                    >
                      Date
                    </th>
                    <th
                      scope="col"
                      style={{
                        padding: "30px 15px",
                        color: "white",
                        backgroundColor: "rgb(251, 148, 4)",
                      }}
                    >
                      Customer
                    </th>
                    <th
                      scope="col"
                      style={{
                        padding: "30px 15px",
                        color: "white",
                        backgroundColor: "rgb(251, 148, 4)",
                      }}
                    >
                      Products
                    </th>
                    <th
                      scope="col"
                      style={{
                        padding: "30px 15px",
                        color: "white",
                        backgroundColor: "rgb(251, 148, 4)",
                      }}
                    >
                      Order Total
                    </th>
                    <th
                      scope="col"
                      style={{
                        padding: "30px 15px",
                        color: "white",
                        backgroundColor: "rgb(251, 148, 4)",
                      }}
                    >
                      Order Status
                    </th>
                    <th
                      scope="col"
                      style={{
                        padding: "30px 15px",
                        color: "white",
                        backgroundColor: "rgb(251, 148, 4)",
                      }}
                    >
                      Payment Status
                    </th>

                    <th
                      scope="col"
                      style={{
                        padding: "30px 15px",
                        color: "white",
                        backgroundColor: "rgb(251, 148, 4)",
                      }}
                    >
                      Courier
                    </th>

                    <th
                      scope="col"
                      style={{
                        padding: "30px 15px",
                        color: "white",
                        backgroundColor: "rgb(251, 148, 4)",
                      }}
                    >
                      Invoice
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {renderableOrders.map((order, index) => (
                    <tr key={index}>
                      <th
                        scope="row"
                        data-toggle="modal"
                        data-target="#detailInfoModal"
                        onClick={() => {
                          this.setState({
                            orderObj: order,
                          });
                        }}
                      >
                        {index + 1}
                      </th>
                      <td
                        scope="row"
                        data-toggle="modal"
                        data-target="#detailInfoModal"
                        onClick={() => {
                          this.setState({
                            orderObj: order,
                          });
                        }}
                      >
                        {order.id}
                      </td>
                      <td
                        data-toggle="modal"
                        data-target="#detailInfoModal"
                        onClick={() => {
                          this.setState({
                            orderObj: order,
                          });
                        }}
                      >
                        {new Date(Number(order.date)).toLocaleDateString()}
                      </td>
                      <td
                        data-toggle="modal"
                        data-target="#detailInfoModal"
                        onClick={() => {
                          this.setState({
                            orderObj: order,
                          });
                        }}
                      >
                        {order.currentUser?.displayName}
                      </td>

                      <td
                        data-toggle="modal"
                        data-target="#detailInfoModal"
                        onClick={() => {
                          this.setState({
                            orderObj: order,
                          });
                        }}
                      >
                        <div
                          style={{
                            color: "white",
                            padding: "3px 10px",
                            borderRadius: 5,
                            backgroundColor: "cadetblue",
                            textAlign: "center",
                            cursor: "pointer",
                            display: "inline-block",
                            alignItems: "center",
                            fontSize: 13,
                          }}
                        >
                          View
                        </div>
                      </td>

                      <td
                        data-toggle="modal"
                        data-target="#detailInfoModal"
                        onClick={() => {
                          this.setState({
                            orderObj: order,
                          });
                        }}
                      >
                        ৳{" "}
                        {order.subTotal +
                          order.deliveryCharge -
                          order.discountApplied -
                          (order.couponApplied
                            ? order.couponApplied.discount
                            : 0) -
                          (order.finalDiscount ? order.finalDiscount : 0)}
                      </td>

                      <td
                        data-toggle="modal"
                        data-target="#detailInfoModal"
                        onClick={() => {
                          this.setState({
                            orderObj: order,
                          });
                        }}
                      >
                        <div
                          style={{
                            color: "white",
                            padding: "3px 10px",
                            borderRadius: 5,
                            backgroundColor:
                              order.orderStatus == "Processing"
                                ? "#0f0fd9"
                                : order.orderStatus == "Confirmed"
                                  ? "orange"
                                  : order.orderStatus == "Packing"
                                    ? "darkorange"
                                    : order.orderStatus == "On the way"
                                      ? "green"
                                      : order.orderStatus == "Delivered"
                                        ? "green"
                                        : "red",
                            textAlign: "center",
                            cursor: "pointer",
                            display: "inline-block",
                            fontSize: 11,
                          }}
                        >
                          {order.orderStatus}
                        </div>
                      </td>
                      <td>
                        <span
                          style={{
                            padding: "1px 6px",
                            fontWeight: "bold",
                            color: "white",
                            borderRadius: 5,
                            background: order
                              ? order.paymentStatus == "Partially Paid"
                                ? "darkorange"
                                : order.paymentStatus == "Not Paid"
                                  ? "red"
                                  : order.paymentStatus == "Paid"
                                    ? "green"
                                    : order.paymentStatus == "purchaseLater"
                                      ? "gray"
                                      : order.paymentStatus == "pending"
                                        ? "darkorange"
                                        : "red"
                              : "red",
                            textAlign: "center",
                            fontSize: 11,
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            this.setState({
                              orderObj: order,
                            });
                          }}
                        >
                          {(order && order.paymentStatus) || "Not Paid"}
                        </span>
                      </td>
                      {order.orderStatus == "Processing" ||
                      order.orderStatus == "Confirmed" ? (
                        <td></td>
                      ) : (
                        <td>
                          {order.courier && order.courier.pathao ? (
                            <div
                              style={{
                                display: "inline",
                                padding: "2px 7px",
                                borderRadius: 4,
                                color: "white",
                                background: "rgb(236 52 91)",
                                cursor: "pointer",
                                fontSize: 11,
                              }}
                              data-toggle="modal"
                              data-target="#courierModal"
                              onClick={async () => {
                                let baseUrl = `https://admin.chinatrade.com.bd`;
                                axios
                                  .get(`${baseUrl}/api/issue-token`, {
                                    headers: {
                                      "Content-Type": "application/json",
                                    },
                                  })
                                  .then((response) => {
                                    console.log("Token Issued:", response);
                                    if (response.status == 200) {
                                      // upon getting success access_token get the city list and zone list
                                      let access_token =
                                        response.data.access_token;
                                      this.setState({
                                        access_token,
                                      });
                                      axios
                                        .get(
                                          `${baseUrl}/api/order-info/${order.courier.consignment_id}`,
                                          {
                                            headers: {
                                              "Content-Type":
                                                "application/json",
                                              Authorization: `Bearer ${access_token}`,
                                            },
                                          },
                                        )
                                        .then((response) => {
                                          console.log(response.data);
                                          this.setState({
                                            orderObj: {
                                              ...order,
                                              deliveryStatus:
                                                response.data &&
                                                response.data.data.order_status
                                                  ? response.data.data
                                                      .order_status
                                                  : "",
                                              deliveryStatusDescription: `Your Order is ${response.data.data.order_status}`,
                                            },
                                            orderStatus: order.orderStatus,
                                            courier: "Pathao",
                                          });
                                        })
                                        .catch((error) => {
                                          alert("Error getting order Info.");
                                        });
                                    }
                                  })
                                  .catch((error) => {
                                    alert("Error getting access token");
                                  });
                              }}
                            >
                              Pathao
                            </div>
                          ) : order.courier &&
                            order.courier.consignment &&
                            order.courier.consignment.consignment_id ? (
                            <div
                              style={{
                                display: "inline",
                                padding: "2px 7px",
                                borderRadius: 4,
                                color: "white",
                                background: "rgb(0, 183, 149)",
                                cursor: "pointer",
                                fontSize: 11,
                              }}
                              data-toggle="modal"
                              data-target="#courierModal"
                              onClick={async () => {
                                const response = await axios.get(
                                  `${base_url}/status_by_cid/${order.courier.consignment.consignment_id}`,
                                  {
                                    headers: {
                                      "Api-Key": api_key,
                                      "Secret-Key": secret_key,
                                      "Content-Type": "application/json",
                                    },
                                  },
                                );
                                console.log(response.data);
                                let description = "";
                                if (
                                  response.data &&
                                  response.data.delivery_status
                                ) {
                                  if (
                                    response.data.delivery_status == "pending"
                                  ) {
                                    description =
                                      "Consignment is not delivered or cancelled yet.";
                                  } else if (
                                    response.data.delivery_status ==
                                    "delivered_approval_pending"
                                  ) {
                                    description =
                                      "Consignment is delivered but waiting for admin approval.";
                                  } else if (
                                    response.data.delivery_status ==
                                    "partial_delivered_approval_pending"
                                  ) {
                                    description =
                                      "Consignment is delivered partially and waiting for admin approval.";
                                  } else if (
                                    response.data.delivery_status ==
                                    "cancelled_approval_pending"
                                  ) {
                                    description =
                                      "Consignment is cancelled and waiting for admin approval.";
                                  } else if (
                                    response.data.delivery_status ==
                                    "unknown_approval_pending"
                                  ) {
                                    description =
                                      "Unknown Pending status. Need contact with the support team.";
                                  } else if (
                                    response.data.delivery_status == "delivered"
                                  ) {
                                    description =
                                      "Consignment is delivered and balance added.";
                                  } else if (
                                    response.data.delivery_status ==
                                    "partial_delivered"
                                  ) {
                                    description =
                                      "Consignment is partially delivered and balance added.";
                                  } else if (
                                    response.data.delivery_status == "cancelled"
                                  ) {
                                    description =
                                      "Consignment is cancelled and balance updated.";
                                  } else if (
                                    response.data.delivery_status == "hold"
                                  ) {
                                    description = "Consignment is held.";
                                  } else if (
                                    response.data.delivery_status == "in_review"
                                  ) {
                                    description =
                                      "Order is placed and waiting to be reviewed.";
                                  } else if (
                                    response.data.delivery_status == "unknown"
                                  ) {
                                    description =
                                      "Unknown status. Need contact with the support team.";
                                  }
                                }
                                this.setState({
                                  orderObj: {
                                    ...order,
                                    deliveryStatus:
                                      response.data &&
                                      response.data.delivery_status
                                        ? response.data.delivery_status
                                        : "",
                                    deliveryStatusDescription: description,
                                  },
                                  orderStatus: order.orderStatus,
                                  courier: "SteadFast",
                                });
                              }}
                            >
                              SteadFast
                            </div>
                          ) : order && order.courier ? (
                            <div
                              style={{
                                display: "inline",
                                padding: "2px 7px",
                                borderRadius: 4,
                                color: "white",
                                background: "red",
                                cursor: "pointer",
                                fontSize: 13,
                              }}
                            >
                              Cancelled
                            </div>
                          ) : (
                            <>
                              <img
                                data-toggle="modal"
                                data-target="#courierModal"
                                onClick={() => {
                                  this.setState({
                                    orderObj: order,
                                    orderStatus: order.orderStatus,
                                    courier: "SteadFast",
                                  });
                                }}
                                src={SteadFast}
                                style={{
                                  width: "80%",
                                  border: "2px solid #319f82",
                                  borderRadius: 5,
                                  cursor: "pointer",
                                }}
                              />{" "}
                              <br />
                              {/* <img
                                      data-toggle="modal"
                                      data-target="#courierModal"
                                      onClick={async () => {
                                        let baseUrl = `https://admin.chinatrade.com.bd`;
                                        axios
                                          .get(`${baseUrl}/api/issue-token`, {
                                            headers: {
                                              "Content-Type":
                                                "application/json",
                                            },
                                          })
                                          .then((response) => {
                                            console.log(
                                              "Token Issued:",
                                              response
                                            );
                                            if (response.status == 200) {
                                              // upon getting success access_token get the city list and zone list
                                              let access_token =
                                                response.data.access_token;
                                              this.setState({
                                                access_token,
                                              });
                                              axios
                                                .get(
                                                  `${baseUrl}/api/city-list`,
                                                  {
                                                    headers: {
                                                      "Content-Type":
                                                        "application/json",
                                                      Authorization: `Bearer ${access_token}`,
                                                    },
                                                  }
                                                )
                                                .then((response) => {
                                                  //  upon getting city lists find the actual city.

                                                  this.setState(
                                                    {
                                                      cityList:
                                                        response.data.data.data,
                                                    },
                                                    () => {
                                                      console.log(
                                                        this.state.cityList
                                                      );
                                                    }
                                                  );
                                                })
                                                .catch((error) => {
                                                  alert(error);
                                                });
                                            }
                                          })
                                          .catch((error) => {
                                            alert(
                                              "Error creating access token. "
                                            );
                                            console.error(
                                              "Error:",
                                              error.response
                                                ? error.response.data
                                                : error.message
                                            );
                                          });
                                        this.setState({
                                          orderObj: order,
                                          orderStatus: order.orderStatus,
                                          courier: "Pathao",
                                          note: "",
                                          weight: "",
                                          city: null,
                                          cityList: [],
                                          areaList: [],
                                          cityObject: null,
                                          zoneObject: null,
                                          zone: null,
                                        });
                                      }}
                                      src={Pathao}
                                      style={{
                                        width: "80%",
                                        border: "2px solid #ec345b",
                                        borderRadius: 5,
                                        cursor: "pointer",
                                      }}
                                    /> */}
                            </>
                          )}
                        </td>
                      )}
                      <td>
                        <a
                          style={{
                            color: "white",
                            padding: "3px 10px",
                            borderRadius: 5,
                            backgroundColor: "black",
                            textAlign: "center",
                            cursor: "pointer",
                            display: "inline-block",
                            fontSize: 12,
                            fontWeight: "bold",
                          }}
                          href={`https://chinatrade.com.bd/invoice?orderId=${order.id}`}
                          target="_blank"
                        >
                          invoice
                        </a>
                        {this.props.currentAdmin &&
                          this.props.currentAdmin.status != "Employee" && (
                            <span
                              style={{
                                color: "white",
                                padding: "3px 10px",
                                borderRadius: 5,
                                backgroundColor: "darkorange",
                                textAlign: "center",
                                cursor: "pointer",
                                display: "inline-block",
                                fontSize: 12,
                                fontWeight: "bold",
                                marginLeft: 5,
                              }}
                              data-toggle="modal"
                              data-target="#personalInfoModal2"
                              onClick={() => {
                                this.setState({
                                  orderObj: order,
                                  orderStatus: order.orderStatus,
                                });
                              }}
                            >
                              edit
                            </span>
                          )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </TabPanel>
        </Tabs>
        <div
          className="modal fade"
          id="detailInfoModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{
              margin: "auto",
              minWidth: "60%",
              maxHeight: "80%",
              overflowY: "scroll",
            }}
          >
            <div className="modal-content" style={{ top: 10, margin: "auto" }}>
              <div
                className="modal-header"
                style={{
                  backgroundColor: "rgb(251, 148, 4)",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="modal-title"
                  style={{
                    fontWeight: "bold",
                    fontSize: 17,
                    color: "white",
                  }}
                  id="exampleModalLabel"
                >
                  Order Id: {orderObj && orderObj.id}
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true" style={{ color: "white" }}>
                    &times;
                  </span>
                </button>
              </div>
              <div className="modal-body">
                <div style={{ padding: "10px 15px" }}></div>
                <div
                  className="row"
                  style={{
                    marginBottom: 10,
                    borderBottom: "1px solid gainsboro",
                  }}
                >
                  <div className="col">
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                        color: "gray",
                      }}
                    >
                      Order Information
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Order Id:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {" "}
                        #{orderObj && orderObj.id}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Ordered at:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {" "}
                        {orderObj &&
                          new Date(Number(orderObj.date)).toLocaleDateString()}
                        {"  "}
                        {orderObj &&
                          new Date(Number(orderObj.date)).toLocaleTimeString()}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Order Status:{" "}
                      <span
                        style={{
                          padding: 10,
                          fontWeight: "bold",
                          paddingTop: 0,
                          color: "white",
                          padding: "3px 7px",
                          borderRadius: 5,
                          backgroundColor: orderObj
                            ? orderObj.orderStatus == "Processing"
                              ? "#0f0fd9"
                              : orderObj.orderStatus == "Confirmed"
                                ? "orange"
                                : orderObj.orderStatus == "Packing"
                                  ? "darkorange"
                                  : orderObj.orderStatus == "On the way"
                                    ? "green"
                                    : orderObj.orderStatus == "Delivered"
                                      ? "green"
                                      : orderObj.orderStatus == "Cancelled"
                                        ? "red"
                                        : "white"
                            : "white",
                          textAlign: "center",
                          fontSize: 12,
                        }}
                      >
                        {orderObj && orderObj.orderStatus}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Subtotal:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {" "}
                        ৳{orderObj && orderObj.subTotal}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Delivery Charge:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {" "}
                        ৳ {(orderObj && orderObj.deliveryCharge) || "0"}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Discount Applied:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {" "}
                        ৳ {(orderObj && orderObj.discountApplied) || "0"}
                      </span>
                    </div>
                    {orderObj && orderObj.couponApplied && (
                      <div
                        style={{
                          padding: 10,
                          fontWeight: "bold",
                          paddingTop: 0,
                        }}
                      >
                        Coupon Applied{" "}
                        <span
                          style={{
                            color: "rgb(251, 148, 4)",
                            fontWeight: "bold",
                            fontSize: 12,
                          }}
                        >
                          {" "}
                          ({orderObj.couponApplied.name})
                        </span>
                        :{" "}
                        <span style={{ fontWeight: "lighter" }}>
                          {" "}
                          ৳ {(orderObj && orderObj.couponApplied.discount) || 0}
                        </span>
                      </div>
                    )}
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Amount Payable:{" "}
                      <span style={{ fontWeight: "bold" }}>
                        ৳{" "}
                        {orderObj &&
                          orderObj.subTotal +
                            orderObj.deliveryCharge -
                            orderObj.discountApplied -
                            (orderObj.couponApplied
                              ? orderObj.couponApplied.discount
                              : 0)}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Final Discount:{" "}
                      <span style={{ fontWeight: "bold" }}>
                        ৳{" "}
                        {orderObj && orderObj.finalDiscount
                          ? orderObj.finalDiscount
                          : 0}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Amount Payable{" "}
                      <span style={{ fontSize: 11 }}>(after discount)</span>
                      <span style={{ fontWeight: "bold" }}>
                        ৳{" "}
                        {orderObj &&
                          orderObj.subTotal +
                            orderObj.deliveryCharge -
                            orderObj.discountApplied -
                            (orderObj.couponApplied
                              ? orderObj.couponApplied.discount
                              : 0) -
                            (orderObj.finalDiscount
                              ? orderObj.finalDiscount
                              : 0)}
                      </span>
                    </div>
                    {orderObj && orderObj.cancelNote && (
                      <div
                        style={{
                          padding: 10,
                          fontWeight: "bold",
                          paddingTop: 0,
                        }}
                      >
                        Cancellation Note:{" "}
                        <span
                          style={{
                            fontWeight: "bold",
                            fontSize: 13,
                            color: "gray",
                          }}
                        >
                          {orderObj.cancelNote}
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="col">
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                        color: "gray",
                      }}
                    >
                      Schedule Information
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Order Date:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {orderObj &&
                          new Date(Number(orderObj.date)).toLocaleDateString()}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Confirmed Date:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {orderObj &&
                          orderObj.confirmedDate &&
                          new Date(
                            Number(orderObj.confirmedDate),
                          ).toLocaleDateString()}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Packing Date:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {orderObj &&
                          orderObj.packingDate &&
                          new Date(
                            Number(orderObj.packingDate),
                          ).toLocaleDateString()}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Delivered Date:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {orderObj &&
                          orderObj.deliveredDate &&
                          new Date(
                            Number(orderObj.deliveredDate),
                          ).toLocaleDateString()}
                      </span>
                    </div>
                    {orderObj && orderObj.cancelledDate && (
                      <div
                        style={{
                          padding: 10,
                          fontWeight: "bold",
                          paddingTop: 0,
                        }}
                      >
                        Cancelled Date:{" "}
                        <span style={{ fontWeight: "lighter" }}>
                          {orderObj &&
                            orderObj.cancelledDate &&
                            new Date(
                              Number(orderObj.cancelledDate),
                            ).toLocaleDateString()}
                        </span>
                      </div>
                    )}
                    {orderObj && orderObj.orderNote && (
                      <div
                        style={{
                          padding: 10,
                          fontWeight: "bold",
                          paddingTop: 0,
                          marginTop: 30,
                        }}
                      >
                        Order note:{" "}
                        <span style={{ fontWeight: "lighter" }}>
                          {orderObj && orderObj.orderNote}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                        color: "gray",
                      }}
                    >
                      Customer Information
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Customer Id:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {orderObj && orderObj.currentUser.uid}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Customer Name:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {orderObj && orderObj.currentUser.displayName}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Customer Email:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {orderObj && orderObj.currentUser.email}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Customer Mobile No:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {orderObj && orderObj.currentUser.mobielNumber}
                      </span>
                    </div>
                  </div>
                  <div className="col">
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                        color: "gray",
                      }}
                    >
                      Delivery Information
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Name :{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {deliveryAddress && deliveryAddress.fullName}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Mobile :{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {deliveryAddress && deliveryAddress.mobileNo}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Address :{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {deliveryAddress && deliveryAddress.address}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      District :{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {deliveryAddress && deliveryAddress.district}
                      </span>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Division :{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {deliveryAddress && deliveryAddress.division}
                      </span>
                    </div>
                  </div>
                </div>
                <div style={{ marginTop: 30 }}></div>
                <table className="table table-bordered table-striped table-hover">
                  <thead>
                    <tr>
                      <td style={{ fontWeight: "bold" }}>Product Image</td>
                      <td style={{ fontWeight: "bold" }}>Product Name</td>
                      <td style={{ fontWeight: "bold" }}>Product Price</td>
                      <td style={{ fontWeight: "bold" }}>Total Quantity</td>
                      <td style={{ fontWeight: "bold" }}>
                        Available Stock <br />{" "}
                        <span style={{ fontSize: 12, color: "gray" }}>
                          at the time of order
                        </span>
                      </td>
                      <td style={{ fontWeight: "bold" }}>Total Price</td>
                    </tr>
                  </thead>
                  <tbody>
                    {orderObj &&
                      orderObj.orders.map((order) => (
                        <tr key={order.id}>
                          <td>
                            <img
                              style={{ height: 70, width: 70 }}
                              src={
                                order.selectedVariation &&
                                order.selectedVariation.id &&
                                order.selectedVariation.pictures &&
                                order.selectedVariation.pictures.length > 0
                                  ? order.selectedVariation.pictures[0]
                                  : order.product.pictures[0]
                              }
                            />
                          </td>
                          <td>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <div style={{ fontWeight: "bold" }}>
                                {order.product.name.slice(0, 50)}...
                              </div>
                              {order.product.selectedCategories &&
                                order.product.selectedCategories.length > 0 &&
                                order.product.selectedCategories
                                  .slice(0, 2)
                                  .map((cat, index) => (
                                    <div
                                      key={index}
                                      style={{
                                        fontSize: 14,
                                        color: "#444",
                                      }}
                                    >
                                      {cat.name}
                                    </div>
                                  ))}

                              <div style={{ marginTop: 6 }}>
                                {order.selectedVariation &&
                                  order.selectedVariation.id &&
                                  order.selectedVariation.combination.map(
                                    (comb, index) => (
                                      <div key={index}>
                                        {order.product.savedAttributes.find(
                                          (attr) => attr.id == comb.parentId,
                                        )
                                          ? order.product.savedAttributes.find(
                                              (attr) =>
                                                attr.id == comb.parentId,
                                            ).name
                                          : ""}
                                        : {comb.name}
                                      </div>
                                    ),
                                  )}
                              </div>
                              <div>
                                Total:৳ {this.singleProductTotal(order)} (
                                {order.quantity}pc)
                              </div>
                            </div>
                          </td>
                          <td>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-around",
                              }}
                            >
                              {" "}
                              <div
                                style={{
                                  fontSize: 13,
                                  textDecorationLine: "line-through",
                                  color: "gray",
                                }}
                              >
                                {this.getPrice3(order)}{" "}
                              </div>
                              <div
                                style={{
                                  color: "black",
                                  fontSize: 13,
                                  fontWeight: "bold",
                                }}
                              >
                                ৳ {this.getPrice2(order)}
                              </div>
                            </div>
                          </td>
                          <td>{order.quantity}Pc</td>
                          <td>
                            {order.selectedVariation &&
                            order.selectedVariation.inventory
                              ? order.selectedVariation.inventory
                              : order.product.inventory}
                            Pc
                          </td>

                          <td style={{ fontWeight: "bold" }}>
                            ৳ {this.singleProductTotal(order)}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="courierModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto" }}
          >
            <div
              className="modal-content"
              style={{ top: 10, width: "100%", margin: "auto" }}
            >
              <div
                className="modal-header"
                style={{
                  backgroundColor: "rgb(251, 148, 4)",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="modal-title"
                  style={{
                    fontWeight: "bold",
                    fontSize: 17,
                    color: "white",
                  }}
                  id="exampleModalLabel"
                >
                  {orderObj &&
                  orderObj.courier &&
                  orderObj.courier.pathao &&
                  orderObj.courier.consignment_id
                    ? "Consignment has been created at pathao"
                    : orderObj &&
                        orderObj.courier &&
                        orderObj.courier.status == 200
                      ? "Consignment has been created at steadFast"
                      : orderObj &&
                          orderObj.courier &&
                          orderObj.courier.status != 200
                        ? "An error occurred creating the consignment."
                        : "Select Courier"}
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="close-btn-courier"
                >
                  <span aria-hidden="true" style={{ color: "white" }}>
                    &times;
                  </span>
                </button>
              </div>
              {orderObj && (
                <div className="modal-body">
                  <div style={{ padding: "10px 15px" }}>
                    <div className="form-group">
                      {!orderObj.courier && (
                        <div>
                          Are you sure you want to deliver this order with{" "}
                          {this.state.courier}?
                        </div>
                      )}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-start",
                          marginTop: 20,
                        }}
                      >
                        <div style={{ fontWeight: "bold", marginTop: 10 }}>
                          {" "}
                          Selected Courier:{" "}
                        </div>
                        <img
                          src={
                            this.state.courier == "SteadFast"
                              ? SteadFast
                              : Pathao
                          }
                          style={{
                            width: 100,
                            marginLeft: 6,
                            border:
                              this.state.courier == "SteadFast"
                                ? "2px solid #319f82"
                                : "2px solid #e83234",
                            borderRadius: 5,
                          }}
                        />
                      </div>
                      {!orderObj.courier && (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-start",
                            marginTop: 20,
                          }}
                        >
                          <div style={{ minWidth: "100%" }}>
                            {this.state.courier === "Pathao" && (
                              <>
                                <div
                                  // className="form-group"
                                  style={{ minWidth: "100%" }}
                                >
                                  <div style={{ fontWeight: "bold" }}>
                                    Total Weight (in kg)
                                  </div>
                                  <input
                                    name="weight"
                                    value={this.state.weight}
                                    style={{
                                      width: "100%",
                                      borderRadius: 5,
                                      textAlign: "left",
                                      marginTop: 5,
                                      padding: 10,
                                    }}
                                    type="number"
                                    placeholder="Enter Product weight (in kg)"
                                    onChange={(e) => {
                                      this.setState({
                                        weight: e.target.value,
                                      });
                                    }}
                                  />
                                </div>
                                <div
                                  // className="form-group"
                                  style={{ minWidth: "100%", marginTop: 15 }}
                                >
                                  <div style={{ fontWeight: "bold" }}>
                                    Select City
                                  </div>
                                  <select
                                    title=""
                                    name="city"
                                    className="custom-select"
                                    aria-required="true"
                                    aria-invalid="false"
                                    onChange={async (e) => {
                                      const { name, value } = e.target;
                                      let cityObject = this.state.cityList.find(
                                        (city) => city.city_name == value,
                                      );
                                      console.log(this.state.cityList);
                                      console.log(value);
                                      console.log(cityObject);
                                      this.setState(
                                        {
                                          [name]: value,
                                          cityObject: this.state.cityList.find(
                                            (city) => city.city_name == value,
                                          ),
                                        },
                                        async () => {
                                          let baseUrl = `https://admin.chinatrade.com.bd`;
                                          axios
                                            .get(
                                              `${baseUrl}/api/get-zone-list/${this.state.cityObject.city_id}`,
                                              {
                                                headers: {
                                                  "Content-Type":
                                                    "application/json",
                                                  Authorization: `Bearer ${this.state.access_token}`,
                                                },
                                              },
                                            )
                                            .then((response) => {
                                              console.log(response);
                                              this.setState({
                                                areaList:
                                                  response.data.data.data,
                                              });
                                            })
                                            .catch((error) => {
                                              console.log(error);
                                            });
                                        },
                                      );
                                    }}
                                    style={{ fontSize: ".8rem" }}
                                    value={this.state.city}
                                    required
                                  >
                                    <option value="">Select City</option>
                                    {this.state.cityList.map((city) => {
                                      return (
                                        <option value={city.city_name}>
                                          {city.city_name}
                                        </option>
                                      );
                                    })}
                                  </select>
                                </div>
                                <div
                                  // className="form-group"
                                  style={{ minWidth: "100%", marginTop: 15 }}
                                >
                                  <div style={{ fontWeight: "bold" }}>
                                    Select Zone
                                  </div>
                                  <select
                                    title=""
                                    name="zone"
                                    className="custom-select"
                                    aria-required="true"
                                    aria-invalid="false"
                                    onChange={(e) => {
                                      const { name, value } = e.target;
                                      this.setState({
                                        [name]: value,
                                        zoneObject: this.state.areaList.find(
                                          (area) => area.zone_name == value,
                                        ),
                                      });
                                    }}
                                    style={{ fontSize: ".8rem" }}
                                    value={this.state.zone}
                                    required
                                  >
                                    {this.state.cityObject &&
                                    this.state.areaList.length > 0 ? (
                                      <>
                                        <option value="">Select Area</option>
                                        {this.state.areaList.map((area) => {
                                          return (
                                            <option value={area.zone_name}>
                                              {area.zone_name}
                                            </option>
                                          );
                                        })}
                                      </>
                                    ) : (
                                      <option value="">
                                        Select City first
                                      </option>
                                    )}
                                  </select>
                                </div>
                              </>
                            )}

                            <div
                              // className="form-group"
                              style={{ minWidth: "100%", marginTop: 15 }}
                            >
                              <div style={{ fontWeight: "bold" }}>
                                Write Delivery Instruction
                              </div>
                              <textarea
                                name="note"
                                value={this.state.note}
                                style={{
                                  width: "100%",
                                  height: 200,
                                  border: "1px solid gainsboro",
                                  borderRadius: 5,
                                  textAlign: "left",
                                  marginTop: 5,
                                  padding: 10,
                                }}
                                type="search"
                                placeholder="Wrtie delivery instruction to courier partner"
                                onChange={(e) => {
                                  this.setState({
                                    note: e.target.value,
                                  });
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                      <div
                        style={{
                          marginTop: 30,
                          fontWeight: "bold",
                          marginBottom: 6,
                        }}
                      >
                        Courier Information
                      </div>
                      {orderObj &&
                        orderObj.courier &&
                        orderObj.courier.pathao && (
                          <div style={{ marginTop: 5 }}>
                            Consignment Id:{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {orderObj.courier.consignment_id}
                            </span>
                          </div>
                        )}{" "}
                      {orderObj &&
                        orderObj.courier &&
                        orderObj.courier.pathao && (
                          <div style={{ marginTop: 5 }}>
                            Delivery Fee:{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {orderObj.courier.delivery_fee}Tk
                            </span>
                          </div>
                        )}
                      {orderObj &&
                        orderObj.courier &&
                        orderObj.courier.pathao && (
                          <div style={{ marginTop: 5 }}>
                            City (for pathao booking):{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {orderObj.courier.city.city_name}
                            </span>
                          </div>
                        )}
                      {orderObj &&
                        orderObj.courier &&
                        orderObj.courier.pathao && (
                          <div style={{ marginTop: 5 }}>
                            Zone (for pathao booking):{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {orderObj.courier.zone.zone_name}
                            </span>
                          </div>
                        )}
                      {orderObj &&
                        orderObj.courier &&
                        orderObj.courier.pathao && (
                          <div style={{ marginTop: 5 }}>
                            Parcel weight (for pathao booking):{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {orderObj.courier.weight}kg
                            </span>
                          </div>
                        )}
                      {orderObj &&
                        orderObj.courier &&
                        orderObj.courier.consignment && (
                          <div style={{ marginTop: 5 }}>
                            Created At:{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {new Date(
                                orderObj.courier.consignment.created_at,
                              ).toLocaleString("en-BD", {
                                timeZone: "Asia/Dhaka",
                              })}
                            </span>
                          </div>
                        )}
                      {orderObj &&
                        orderObj.courier &&
                        orderObj.courier.consignment && (
                          <div style={{ marginTop: 5 }}>
                            Consignment id:{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {orderObj &&
                                orderObj.courier.consignment.consignment_id}
                            </span>
                          </div>
                        )}
                      {orderObj &&
                        orderObj.courier &&
                        orderObj.courier.consignment && (
                          <div style={{ marginTop: 5 }}>
                            Tracking Code:{" "}
                            <span style={{ fontWeight: "bold" }}>
                              {orderObj &&
                                orderObj.courier.consignment.tracking_code}
                            </span>
                          </div>
                        )}
                      <div style={{ marginTop: 5 }}>
                        Invoice:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {orderObj && orderObj.id}
                        </span>
                      </div>
                      {orderObj && (
                        <div className="wrap-info">
                          {orderObj.currentUser ? (
                            <ul>
                              <li style={{ marginTop: 5 }}>
                                Name :{" "}
                                <span style={{ fontWeight: "bold" }}>
                                  {" "}
                                  {
                                    orderObj.currentUser.address.find(
                                      (address) => address.defaultShipping,
                                    ).fullName
                                  }
                                </span>
                              </li>{" "}
                              <br />
                              <li style={{ marginTop: 5 }}>
                                Mobile No :{" "}
                                <span style={{ fontWeight: "bold" }}>
                                  {" "}
                                  {
                                    orderObj.currentUser.address.find(
                                      (address) => address.defaultShipping,
                                    ).mobileNo
                                  }
                                </span>
                              </li>
                              <br />
                              <li style={{ marginTop: 5 }}>
                                Address :{" "}
                                <span style={{ fontWeight: "bold" }}>
                                  {
                                    orderObj.currentUser.address.find(
                                      (address) => address.defaultShipping,
                                    ).address
                                  }
                                </span>
                              </li>
                              <br />
                              <li style={{ marginTop: 5 }}>
                                District :
                                <span style={{ fontWeight: "bold" }}>
                                  {" "}
                                  {
                                    orderObj.currentUser.address.find(
                                      (address) => address.defaultShipping,
                                    ).district
                                  }
                                </span>
                              </li>
                              <br />
                              <li style={{ marginTop: 5 }}>
                                Division :
                                <span style={{ fontWeight: "bold" }}>
                                  {" "}
                                  {
                                    orderObj.currentUser.address.find(
                                      (address) => address.defaultShipping,
                                    ).division
                                  }
                                </span>
                              </li>
                              <br />
                              {this.state.courier == "Pathao" && (
                                <>
                                  <li style={{ marginTop: 5 }}>
                                    Parcel Weight:
                                    <span style={{ fontWeight: "bold" }}>
                                      {this.state.weight
                                        ? this.state.weight
                                        : 1}
                                      kg
                                    </span>
                                  </li>
                                  <br />
                                  <li style={{ marginTop: 5 }}>
                                    Selected City (for Pathao) :
                                    <span style={{ fontWeight: "bold" }}>
                                      {this.state.cityObject &&
                                        this.state.cityObject.city_name}
                                    </span>
                                  </li>
                                  <br />
                                  <li style={{ marginTop: 5 }}>
                                    Selected Zone (for Pathao) :
                                    <span style={{ fontWeight: "bold" }}>
                                      {" "}
                                      {this.state.zoneObject &&
                                        this.state.zoneObject.zone_name}
                                    </span>
                                  </li>
                                </>
                              )}
                            </ul>
                          ) : (
                            <ul>
                              <li style={{ marginTop: 5 }}>
                                Name :{" "}
                                <span style={{ fontWeight: "bold" }}>
                                  {" "}
                                  {
                                    orderObj.guest.address.find(
                                      (address) => address.defaultShipping,
                                    ).fullName
                                  }
                                </span>
                              </li>
                              <br />
                              <li style={{ marginTop: 5 }}>
                                Mobile No :{" "}
                                <span style={{ fontWeight: "bold" }}>
                                  {" "}
                                  {
                                    orderObj.guest.address.find(
                                      (address) => address.defaultShipping,
                                    ).mobileNo
                                  }
                                </span>
                              </li>
                              <br />
                              <li style={{ marginTop: 5 }}>
                                Address :{" "}
                                <span style={{ fontWeight: "bold" }}>
                                  {
                                    orderObj.guest.address.find(
                                      (address) => address.defaultShipping,
                                    ).address
                                  }
                                </span>
                              </li>
                              <br />
                              <li style={{ marginTop: 5 }}>
                                District :
                                <span style={{ fontWeight: "bold" }}>
                                  {" "}
                                  {
                                    orderObj.guest.address.find(
                                      (address) => address.defaultShipping,
                                    ).district
                                  }
                                </span>
                              </li>
                              <br />
                              <li style={{ marginTop: 5 }}>
                                Division :
                                <span style={{ fontWeight: "bold" }}>
                                  {" "}
                                  {
                                    orderObj.guest.address.find(
                                      (address) => address.defaultShipping,
                                    ).division
                                  }
                                </span>
                              </li>{" "}
                              <br />
                              {this.state.courier == "Pathao" && (
                                <>
                                  {!orderObj.courier && (
                                    <li style={{ marginTop: 5 }}>
                                      Parcel Weight:
                                      <span style={{ fontWeight: "bold" }}>
                                        {this.state.weight && this.state.weight}
                                        kg
                                      </span>
                                    </li>
                                  )}

                                  {!orderObj.courier && (
                                    <>
                                      {" "}
                                      <br />
                                      <li style={{ marginTop: 5 }}>
                                        Selected City (for Pathao) :
                                        <span style={{ fontWeight: "bold" }}>
                                          {this.state.cityObject &&
                                            this.state.cityObject.city_name}
                                        </span>
                                      </li>
                                    </>
                                  )}

                                  {!orderObj.courier && (
                                    <>
                                      <br />
                                      <li style={{ marginTop: 5 }}>
                                        Selected Zone (for Pathao) :
                                        <span style={{ fontWeight: "bold" }}>
                                          {" "}
                                          {this.state.zoneObject &&
                                            this.state.zoneObject.zone_name}
                                        </span>
                                      </li>
                                    </>
                                  )}
                                </>
                              )}
                            </ul>
                          )}
                        </div>
                      )}
                      <div style={{ marginTop: 5 }}>
                        COD Amount:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {amountPayable - totalPaid}
                          Tk
                        </span>
                      </div>
                      <div style={{ marginTop: 5 }}>
                        Note: <br />
                        <span
                          style={{
                            fontSize: 12,
                            marginTop: 2,
                            fontWeight: "bold",
                          }}
                        >
                          {!orderObj.courier
                            ? this.state.note
                            : orderObj.courier.note}
                        </span>
                      </div>
                    </div>
                  </div>
                  {orderObj &&
                    orderObj.courier &&
                    orderObj.courier.consignment && (
                      <div style={{ marginLeft: 12 }}>
                        <div style={{ fontWeight: "bold" }}>
                          Tracking Details
                        </div>
                        <div style={{ marginTop: 5 }}>
                          Delivery Status:{" "}
                          <span
                            style={{
                              fontWeight: "bold",
                              color: "white",
                              background: "#00B795",
                              borderRadius: 5,
                              padding: "0px 10px",
                            }}
                          >
                            {orderObj.deliveryStatus}
                          </span>
                        </div>
                        <div style={{ marginTop: 5 }}>
                          Status Details:{" "}
                          <span style={{ fontWeight: "bold" }}>
                            {orderObj.deliveryStatusDescription}
                          </span>
                        </div>
                      </div>
                    )}
                  {orderObj && orderObj.courier && orderObj.courier.pathao && (
                    <div style={{ marginLeft: 12 }}>
                      <div style={{ fontWeight: "bold" }}>Tracking Details</div>
                      <div style={{ marginTop: 5 }}>
                        Delivery Status:{" "}
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "white",
                            background: "#00B795",
                            borderRadius: 5,
                            padding: "0px 10px",
                          }}
                        >
                          {orderObj.deliveryStatus}
                        </span>
                      </div>
                      <div style={{ marginTop: 5 }}>
                        Status Details:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {orderObj.deliveryStatusDescription}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {orderObj && !orderObj.courier && (
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn "
                    data-dismiss="modal"
                    style={{
                      backgroundColor: "red",
                      color: "white",
                      padding: 8,
                      borderRadius: 5,
                      fontWeight: "lighter",
                    }}
                  >
                    No
                  </button>
                  <button
                    type="button"
                    className="btn"
                    style={{
                      backgroundColor: "darkgreen",
                      color: "white",
                      padding: 8,
                      borderRadius: 5,
                      fontWeight: "lighter",
                    }}
                    onClick={() => {
                      this.handleCourier(amountPayable - totalPaid);
                    }}
                  >
                    Yes
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};
export default connect(mapStateToProps)(Tabset_user);
